import { OrderFieldsFragment } from '../../../graphql';
import { getOrderTitle } from '../../utils/getOrderTitle';

export type StatusProps = React.HTMLAttributes<HTMLHeadingElement> &
	Pick<OrderFieldsFragment, 'status' | 'time'>;

export const Status: React.FC<StatusProps> = ({ status, time, ...props }) => {
	const title = getOrderTitle(status.status, time);

	return (
		<h2
			className="order-confirm-title text-primary font-weight-bold mt-4 mb-0 order-status"
			{...props}
		>
			{title}
		</h2>
	);
};
